import { SvgIconProps } from '@material-ui/core/SvgIcon';
import {
  Adjust,
  Build,
  Business,
  ExitToApp,
  History,
  InsertChart,
  LocalShipping,
  Person,
  SettingsApplications,
  TripOrigin,
} from '@material-ui/icons';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const MenuContainer = styled.nav`
  display: flex;
  margin-bottom: 25px;
  width: 100%;
  height: 100%;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: row;
    margin-bottom: 0;
    height: auto;
    position: absolute;
  }
`;

const Box = styled.div`
  background: #fff;
  width: 10px;
  height: 20px;
  margin-left: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Link = styled(NavLink)`
  height: 68px;
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
  box-shadow: inset 0 -1px rgba(255, 255, 255, 0.15);
  display: flex;
  font-size: 16px;
  align-items: center;
  color: ${(props) => props.theme.palette.primary.contrastText};
  transition: ${(props) => props.theme.transitions.create()};
  text-decoration: none;
  opacity: 0.7;

  &:not(.active) ${Box} {
    opacity: 0.5;
  }

  &&.active {
    opacity: 1;
    background-color: ${(props) => props.theme.palette.primary.main};
  }

  &:hover {
    opacity: 1;
    background-color: ${(props) => props.theme.palette.action.hover};
  }
`;

const Name = styled.div`
  padding-left: 10px;
  @media (max-width: 768px) {
    display: none;
  }
`;

const LogoutMenuLink = styled(MenuLink)`
  margin-top: auto;
`;

type MenuLinkProps = {
  to: string;
  icon: React.ComponentType<SvgIconProps>;
  name: string;
};

export function MenuLink({ to, icon: Icon, name }: MenuLinkProps) {
  return (
    <Link to={to} activeClassName="active">
      <Icon fontSize="small" />
      <Name>{name}</Name>
      <Box />
    </Link>
  );
}

export default function MainMenu() {
  const links = [
    { to: '/surfaces', name: 'Renkaat', icon: TripOrigin },
    { to: '/reports', name: 'Raportointi', icon: InsertChart },
    { to: '/maintenances', name: 'Huollot', icon: Build },
    { to: '/actions', name: 'Toimenpiteet', icon: History },
    { to: '/vehicles', name: 'Ajoneuvot', icon: LocalShipping },
    { to: '/customers', name: 'Asiakkaat', icon: Business },
    { to: '/products', name: 'Tuotteet', icon: Adjust },
    { to: '/services', name: 'Työt- & Tarv.', icon: SettingsApplications },
    { to: '/users', name: 'Käyttäjät', icon: Person },
  ];

  return (
    <MenuContainer>
      {links.map((link) => (
        <MenuLink
          key={link.to}
          to={link.to}
          icon={link.icon}
          name={link.name}
        />
      ))}
      <LogoutMenuLink to="/logout" name="Kirjaudu ulos" icon={ExitToApp} />
    </MenuContainer>
  );
}
